"use strict";

(function () {
  document.addEventListener("DOMContentLoaded", function () {

    // TODO:本番で外す↓↓↓ ========================================================
    // if (!is_preview()) { return }

    // フォームに「testmode」を追加
    // const tesmode_input_elms = document.querySelectorAll('[name="keyword"]');
    // if (tesmode_input_elms.length) {
    //   tesmode_input_elms.forEach(function (elm) {
    //     elm.insertAdjacentHTML('beforebegin', '<input type="hidden" name="testmode">')
    //   });
    // }

    // 不要要素を非表示
    const tesmode_hide_array = [
      '#ProductGridContainer',
      '.template-search--empty .keyword-empty',
    ]
    const tesmode_hide_elms = document.querySelectorAll(tesmode_hide_array.join(','));
    if (tesmode_hide_elms.length && (location.pathname === '/search' || location.pathname === '/search/')) {
      tesmode_hide_elms.forEach(function (elm) {
        elm.remove();
      });
    }

    const template_search__empty = document.querySelector('.template-search--empty');
    if (!!template_search__empty) {
      template_search__empty.style.paddingBottom = '30px';
    }

    const q_container_area = document.querySelector('#q_container');
    if (!!q_container_area) {
      q_container_area.style.display = 'block';
    }

    // TODO:本番で外す↑↑↑ ========================================================

    let endpoint_url__search_product = "http://p1bizprd.ukw.jp/p1/v1/hasegawa/";
    let endpoint_url__searchcontents_product = "http://p1bizprd.ukw.jp/p1/v1/hasegawacontents/";
    if (is_preview()) {
      endpoint_url__search_product = "http://p1bizstg.ukw.jp/p1/v1/hasegawa/"
      endpoint_url__searchcontents_product = "http://p1bizstg.ukw.jp/p1/v1/hasegawacontents/"
    }

    const combo_config = {
      combo_butsudan: {
        search_endpoint: endpoint_url__search_product,
        use: {
          search: true,
          facet: false,
          pagination: false,
          sort: false,
          total_count: true,
          suggest: false,
          log: true,
          fallback: true,
        },
        search: {
          param_key: [
            "kw", // キーワード（必須）
            "page", // ページ（必須）
            "rows", // 表示数（必須）
            "sort", // 並び順（必須）
          ],
          rows: {
            13: true,
          },
        },
        total_count: [
          {
            template_name: "default",
          },
        ],
        log: {
          client: 'hasegawa'
        }
      },
      combo_memorial: {
        search_endpoint: endpoint_url__search_product,
        use: {
          search: true,
          total_count: true,
          log: true,
          fallback: true,
          pagination: false,
        },
        search: {
          param_key: [
            "kw", // キーワード（必須）
            "page", // ページ（必須）
            "rows", // 表示数（必須）
            "sort", // 並び順（必須）
          ],
          rows: {
            13: true,
          },
        },
        pagination: {
          edge: true,
          leader: true,
          arrow: true,
          count: 2,
        },
        total_count: [
          {
            template_name: "default",
          },
        ],
        log: {
          client: 'hasegawa'
        }
      },
      combo_blog: {
        search_endpoint: endpoint_url__searchcontents_product,
        use: {
          search: true,
          total_count: true,
          log: false,
          fallback: true,
          pagination: false,
        },
        search: {
          param_key: [
            "kw", // キーワード（必須）
            "page", // ページ（必須）
            "rows", // 表示数（必須）
            "sort", // 並び順（必須）
          ],
          rows: {
            13: true,
          },
        },
        pagination: {
          edge: true,
          leader: true,
          arrow: true,
          count: 2,
        },
        total_count: [
          {
            template_name: "default",
          },
        ],
        log: {
          client: 'hasegawa'
        }
      },
      combo_shop: {
        search_endpoint: endpoint_url__searchcontents_product,
        use: {
          search: true,
          total_count: true,
          log: false,
          fallback: true,
          pagination: false,
        },
        search: {
          param_key: [
            "kw", // キーワード（必須）
            "page", // ページ（必須）
            "rows", // 表示数（必須）
            "sort", // 並び順（必須）
          ],
          rows: {
            13: true,
          },
        },
        pagination: {
          edge: true,
          leader: true,
          arrow: true,
          count: 2,
        },
        total_count: [
          {
            template_name: "default",
          },
        ],
        log: {
          client: 'hasegawa'
        }
      },
    }

    const search_config = {
      butsudan: {
        search_endpoint: endpoint_url__search_product,
        use: {
          search: true,
          facet: false,
          pagination: true,
          sort: true,
          total_count: true,
          suggest: false,
          log: true,
          fallback: true,
        },
        search: {
          param_key: [
            "kw", // キーワード（必須）
            "page", // ページ（必須）
            "rows", // 表示数（必須）
            "sort", // 並び順（必須）
          ],
          rows: {
            24: true,
          },
        },
        pagination: {
          edge: true,
          leader: true,
          arrow: true,
          count: 2,
        },
        sort: [
          {
            template_name: "select",
            options: [
              {
                label: "おすすめ",
                param_key: "score",
                sort: "desc",
              },
              {
                label: "価格の安い順",
                param_key: "price",
                sort: "asc",
              },
              {
                label: "価格の高い順",
                param_key: "price",
                sort: "desc",
              },
            ]
          }
        ],
        total_count: [
          {
            template_name: "default",
          },
        ],
        log: {
          client: 'hasegawa'
        }
      },
      memorial: {
        search_endpoint: endpoint_url__search_product,
        use: {
          search: true,
          pagination: true,
          sort: true,
          total_count: true,
          log: true,
          fallback: true,
        },
        search: {
          param_key: [
            "kw", // キーワード（必須）
            "page", // ページ（必須）
            "rows", // 表示数（必須）
            "sort", // 並び順（必須）
          ],
          rows: {
            24: true,
          },
        },
        pagination: {
          edge: true,
          leader: true,
          arrow: true,
          count: 2,
        },
        total_count: [
          {
            template_name: "default",
          },
        ],
        log: {
          client: 'hasegawa'
        }
      },
      blog: {
        search_endpoint: endpoint_url__searchcontents_product,
        use: {
          search: true,
          facet: false,
          pagination: true,
          sort: true,
          total_count: true,
          suggest: false,
          log: true,
          fallback: true,
        },
        search: {
          param_key: [
            "kw", // キーワード（必須）
            "page", // ページ（必須）
            "rows", // 表示数（必須）
            "sort", // 並び順（必須）
          ],
          rows: {
            24: true,
          },
        },
        pagination: {
          edge: true,
          leader: true,
          arrow: true,
          count: 2,
        },
        sort: [
        ],
        total_count: [
          {
            template_name: "default",
          },
        ],
        suggest: {
          keyword: {
            max: 10,
            title: "キーワードサジェスト",
          },
        },
        log: {
          client: 'hasegawacontents'
        }
      },
      shop: {
        search_endpoint: endpoint_url__searchcontents_product,
        use: {
          search: true,
          pagination: true,
          sort: true,
          total_count: true,
          suggest: false,
          log: true,
          fallback: true,
        },
        search: {
          param_key: [
            "kw", // キーワード（必須）
            "page", // ページ（必須）
            "rows", // 表示数（必須）
            "sort", // 並び順（必須）
          ],
          rows: {
            24: true,
          },
        },
        pagination: {
          edge: true,
          leader: true,
          arrow: true,
          count: 2,
        },
        sort: [
        ],
        total_count: [
          {
            template_name: "default",
          },
        ],
        suggest: {
          keyword: {
            max: 10,
            title: "キーワードサジェスト",
          },
        },
        log: {
          client: 'hasegawacontents'
        }
      },
    }

    const suggest_config = {
      hasegawa_suggest_product: {
        testmode: false,
        keep_word: true,
        suggest_endpoint: "https://s3bizprd.ukw.jp/qsuggest/v1/hasegawa/",
        use: {
          search: false,
          suggest: true,
        },
        suggest: {
          history: {
            max: 5,
            title: null,
          },
          keyword: {
            max: 7,
            title: null,
            theme: 'keyword',
          },
          dr_productname: {
            max: 1,
            title: null,
            theme: 'butsudan',
          },
          dr_placename: {
            max: 1,
            title: null,
            theme: 'memorial',
          },
          dr_category: {
            max: 1,
            title: null,
            theme: 'category',
          },
        },
      },
      hasegawa_suggest_content: {
        testmode: false,
        suggest_endpoint: "https://s3bizprd.ukw.jp/qsuggest/v1/hasegawacontents/",
        use: {
          search: false,
          suggest: true,
        },
        suggest: {
          // history: {
          //   max: 5,
          //   title: null,
          // },
          // keyword: {
          //   max: 5,
          //   title: null,
          //   theme: 'keyword',
          // },
          dr_productname: {
            max: 2,
            title: null,
            theme: 'blog',
          },
          dr_placename: {
            max: 2,
            title: null,
            theme: 'shop',
          },
        },
      },
    }

    /*****************************
     * 検索ページ用
     *****************************/
    if (location.pathname === '/search' || location.pathname === '/search/') {
      window.qSearchUpdate = function qSearchUpdate() {
        const url = new URL(location.href);
        const search_theme = url.searchParams.get('fq.theme');

        if (search_theme === '' || search_theme === null) {

          // コンボページの検索アプリを実行
          setThemeNameToContainer(search_theme)
          const search_config_keys = Object.keys(combo_config);
          combo_request();

          async function combo_request() {
            for (let i = 0; i < search_config_keys.length; i++) {
              const key = search_config_keys[i];

              await new Promise((resolve, reject) => {
                setTimeout(() => {
                  const QAPP = new Q(key, combo_config[key]);
                  QAPP.search.setSearchResultElms('.q_' + key + ' .q_search_result');
                  QAPP.search.setTotalCountResultElms('.q_' + key + ' .q_total_count_result');
                  QAPP.create();

                  resolve('done!');
                }, 700);
              });
            }
          }

          // setThemeNameToContainer(search_theme)
          // Object.keys(combo_config).forEach(key => {
          //   const QAPP = new Q(key, combo_config[key]);
          //   QAPP.search.setSearchResultElms('.q_' + key + ' .q_search_result');
          //   //QAPP.search.setPaginationResultElms('.q_' + key + ' .q_pagination_result');
          //   QAPP.search.setTotalCountResultElms('.q_' + key + ' .q_total_count_result');
          //   QAPP.create();
          //   // console.log('QAPP::' + key, QAPP);
          // })

        } else {
          // 各テーマの検索アプリを実行
          Object.keys(search_config).forEach(key => {
            if (search_theme === key) {
              setThemeNameToContainer(key)
              const QAPP = new Q(key, search_config[key]);
              QAPP.create();
              // console.log('QAPP::' + key, QAPP);
            }
          })
        }
        setThemeBtnActive(search_theme);
      }
      window.qSearchUpdate();

      window.addEventListener('popstate', () => {
        window.qSearchUpdate()
      })
    }

    /*****************************
     * サジェスト用
     *****************************/
    // TODO:本番で外す↓↓↓
    // const suggest_inputs = document.querySelectorAll('[name="keyword"]');
    // if (!!suggest_inputs.length) {
    //   suggest_inputs.forEach(inp => {
    //     inp.setAttribute('name', 'kw');
    //     inp.classList.add('q_suggest_wrapper');
    //   })
    // }
    // TODO:本番で外す↑↑↑

    Object.keys(suggest_config).forEach(key => {
      const QAPP = new Q(key, suggest_config[key]);
      QAPP.create();
      // console.log('QAPP::' + key, QAPP);
    })

    // 検索ページのテーマ切替ボタンにactiveを追加
    function setThemeBtnActive(search_theme) {
      const theme_btns = document.querySelectorAll('#q_theme_menu [data-q-theme-btn]');
      if (theme_btns.length) {
        theme_btns.forEach(btn => {
          if (btn.dataset['qThemeBtn'] == search_theme) {
            btn.classList.add('active')
          } else {
            btn.classList.remove('active')
          }
        })
      }
    }

    // #q_containerにtheme名のクラスを追加
    function setThemeNameToContainer(search_theme) {
      const q_container = document.querySelector('#q_container');
      if (!q_container) { return }

      if (search_theme === '' || search_theme === null) {
        q_container.classList.add('combo')
      } else {
        q_container.classList.remove('combo');
      }

      Object.keys(search_config).forEach(key => {
        if (q_container.classList.contains(key)) {
          if (search_theme === key) { return };
          q_container.classList.remove(key)
        } else {
          if (search_theme !== key) { return };
          q_container.classList.add(key)
        }
      })

    }


    /*****************************
     * 関連ワード
     *****************************/
    (function createRelationalWord() {

      const _url = new URL(location.origin + '/search' + location.search);
      const _kw = _url.searchParams.get('kw');
      if (!_kw) { return }

      const options = {
        kw: _kw,
        wt: 'jsonp',
        rows: 5,
      }

      let string_param = '?';
      Object.entries(options).forEach(([key, val]) => {
        string_param += `${key}=${val}`;
      });
      try {
        string_param = encodeURIComponent(string_param);
      } catch (error) { }

      $.ajax({
        type: 'GET',
        url: 'https://s3bizprd.ukw.jp/rword/v1/hasegawa/',
        data: options,
        dataType: 'jsonp',
        jsonp: 'cbk',
        cache: false,
        timeout: 5000
      })
        .done(function (data) {
          console.log('RelationalWord::', data);
          if (data !== void 0
            && data.response !== void 0
            && data.response.numFound !== void 0
            && data.response.numFound == 0
          ) {
            return
          }

          const $target_elm = $('.search-list-input');
          if (!$target_elm.length) { return }


          const $q_relation_word_wraper = $('.q_relation_word_wraper');
          if ($q_relation_word_wraper.length) {
            $q_relation_word_wraper.each(function () {
              $(this).remove();
            })
          }

          let html = `<div class="q_relation_word_wraper">
          <span class="q_relation_word_title">関連ワード：</span>
        `;
          if (data !== void 0
            && data.response !== void 0
            && data.response.relatedWord !== void 0
            && data.response.relatedWord.docs !== void 0
            && data.response.relatedWord.docs.item !== void 0
          ) {
            data.response.relatedWord.docs.item.forEach(list => {
              _url.searchParams.set('kw', list.word);
              const _link = _url.toString()
              html += `<span class="q_relation_word_text"><a href="${_link}">${list.word}</a></span>`;
            })
          }
          html += `</div>`;
          $target_elm.after(html)

        })
        .fail((jqXHR, textStatus) => {
          console.error('$request', textStatus)
        });
    })();


    /*****************************
     * 共通
     *****************************/
    function is_preview() {
      const testmode = !!location.search.match(/testmode/);
      const admin_bar = !!document.getElementById('admin-bar-iframe');
      return testmode// && admin_bar;
    }

  });
})();
